import { useQueryOrganizationUsers } from '@api/hooks/organization/organizationQuery';

export function useGetOrganizationMembers({ organizationUuid, skip, rowsPerPage }) {
  return useQueryOrganizationUsers({ organizationUuid, skip, rowsPerPage });
}
